import angular from 'angular';
import $ from 'jquery';
import template from './template.html';
import './style.scss';
import {
    summernoteOptions,
    VIEW_STATE,
    EDIT_STATE,
} from '../../../summernote-options';

export class LinkedinInmailTextArea {
    /* @ngInject */
    constructor($timeout) {
        this.$timeout = $timeout;
    }

    internalEmail = '';

    originalEmail = '';

    messageTextareaState = VIEW_STATE;

    subjectTextareaState = VIEW_STATE;

    summernotes = [];

    summernoteOptions = {
        ...summernoteOptions,
        callbacks: {
            onInit: (summernote) => {
                this.summernotes.push(summernote);

                const { toolbar, editable } = summernote;
                const $win = $(window);
                const $noteEditor = $('.note-editor');

                toolbar.hide();
                $win.on('click.Bst', (event) => {
                    if ($noteEditor.has(event.target).length === 0 && !$noteEditor.is(event.target)) {
                        toolbar.hide();
                    }
                });
                editable.focus(() => toolbar.show());

                this.setState(VIEW_STATE);
            },
        },
    };

    $onChanges() {
        this.internalEmail = angular.copy(this.email);
        this.originalEmail = angular.copy(this.internalEmail);
    }

    onEditMessage() {
        this.setMessageState(EDIT_STATE);
    }

    onEditSubject() {
        this.setSubjectState(EDIT_STATE);
    }

    onSaveMessage() {
        this.onEmailChange({ message: this.internalEmail.message });
        this.setMessageState(VIEW_STATE);
    }

    onSaveSubject() {
        this.onEmailChange({ subject: this.internalEmail.subject });
        this.setSubjectState(VIEW_STATE);
    }

    onCancelEditSubject() {
        this.internalEmail.subject = angular.copy(this.originalEmail.subject);

        this.setSubjectState(VIEW_STATE);
    }

    onCancelEditMessage() {
        this.internalEmail.message = angular.copy(this.originalEmail.message);

        this.setMessageState(VIEW_STATE);
    }

    setState(state) {
        this.setMessageState(state);
        this.setSubjectState(state);
    }

    setMessageState(state) {
        const summernoteEditableState = state === EDIT_STATE;

        this.setSummernoteEditableState(summernoteEditableState);
        this.messageTextareaState = state;
        this.onEditMessageStateChange({ state });
    }

    setSubjectState(state) {
        const summernoteEditableState = state === EDIT_STATE;

        this.setSummernoteEditableState(summernoteEditableState);
        this.subjectTextareaState = state;
        this.onEditSubjectStateChange({ state });
    }

    setSummernoteEditableState(state) {
        (this.summernotes || []).forEach(summernote => {
            const { editable } = summernote;

            if (editable) {
                $(editable)
                    .prop('contenteditable', state);
            }
        });
    }
}

export const linkedinInmailTextAreaConfiguration = {
    template,
    bindings: {
        email: '<',
        textareaState: '<',
        onEmailChange: '&',
        onEditMessageStateChange: '&',
        onEditSubjectStateChange: '&',
    },
    controller: LinkedinInmailTextArea,
    controllerAs: 'ctrl',
};

angular
    .module('TALENYA-FE')
    .component('linkedinImTextarea', linkedinInmailTextAreaConfiguration);
